"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Axxess = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class Axxess {
    constructor() {
        this.isCopyPasteFromWebsite = true;
    }
    /**********************************************************************************************************************
     *                     START : AXXESS Software Parser
     * ********************************************************************************************************************/
    /**
     * @function axxessSoftwareParser
     * @param pastedData
     * @param event
     * @param callbackEmit
     * @summary AXXESS Software Parser @pastedData string break by session to session
     * @returns {callback}
     */
    parse(pastedData, event, callbackEmit) {
        try {
            //Replace all next line from `pastedData`
            pastedData = pastedData.replace(/\n/g, "");
            //Default
            this.isCopyPasteFromWebsite = true;
            const numberOfNextLine = pastedData.match(/\n/g);
            if ((0, helper_1.arrayLength)(numberOfNextLine) > 20) {
                this.isCopyPasteFromWebsite = false;
            }
            let sessionFirst;
            //**Session 1 Patient name*/
            //Note: For if user copy/paste from assess website
            if (this.isCopyPasteFromWebsite) {
                sessionFirst = pastedData.substring(pastedData.indexOf("Secondary Emergency Contact") + 27);
            }
            else {
                //Note: For if user copy/paste after download pdf
                sessionFirst = pastedData.substring(pastedData.indexOf("SecondaryEmergency Contact") + 28);
            }
            let sessionSecond;
            //**Session 2 Patient Information*/
            if (this.isCopyPasteFromWebsite) {
                sessionSecond = (0, helper_1.substrInBetween)(pastedData, "Patient Demographics", "Marital Status:");
            }
            else {
                //Note: For if user copy/paste after download pdf
                sessionSecond = (0, helper_1.substrInBetween)(pastedData, "Patient Demographics", "MaritalStatus:");
            }
            const patientInfo = this.gettingPatientDetails(sessionFirst, sessionSecond);
            let sessionThird;
            //**Session 3 Insurance*/
            //Replace Member Id to Medicare part .....:
            if (pastedData.indexOf("Member ID:") != 1) {
                pastedData = pastedData.replace("Member ID:", "Medicare Part A Effective:");
            }
            //Note: For if user copy/paste from assess website.
            if (this.isCopyPasteFromWebsite) {
                sessionThird = (0, helper_1.substrInBetween)(pastedData, "Primary Insurance:", "Medicare Part A Effective:");
            }
            else {
                //Note: For if user copy/paste after download pdf
                sessionThird = (0, helper_1.substrInBetween)(pastedData, "PrimaryInsurance:", "Medicare Part A Effective:");
            }
            const insurance = this.getInsurance(sessionThird);
            //**Session 6 Emergency Contact*/
            const sessionSix = (0, helper_1.substrInBetween)(pastedData, "Emergency Contact:", "Primary Physician:");
            //**Session 7 Primary Physician*/
            const sessionSeven = (0, helper_1.substrInBetween)(pastedData, "Referring:", "Certifying:");
            //**Session 8 Pharmacy*/
            const sessionEight = (0, helper_1.substrInBetween)(pastedData, "Pharmacy:", "Comments");
            const physicianInfo = this.getPrimaryPhysician(sessionSix, sessionSeven, sessionEight);
            //**Session 9 Comments*/
            const sendCallBackData = Object.assign(Object.assign(Object.assign({}, patientInfo), insurance), physicianInfo);
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error === null || error === void 0 ? void 0 : error.message : error,
                errorStack: error === null || error === void 0 ? void 0 : error.stack,
            });
        }
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from Axxess
     */
    gettingPatientDetails(sessionFirst, sessionSecond) {
        if (!sessionSecond) {
            return {};
        }
        let convertToArray;
        //For isCopyPasteFromWebsite
        sessionSecond = sessionSecond.replace(/Social Security Number:|MRN:/gi, " SocialSecurity Number:");
        //Get DOB string to array
        convertToArray = (0, helper_1.substrInBetween)(sessionSecond, "DOB:", "SocialSecurity Number:").split(/\n/g);
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(sessionFirst)), this.patientPhoneNumberWithAddress(sessionSecond)), { email: (0, helper_1.getEmailAddress)(sessionSecond), dob: (0, helper_1.getDOB)(convertToArray[0] ? convertToArray[0] : convertToArray[1], true) }),
        };
    }
    /**
     * @function getInsurance
     * @param sessionThird
     * @summary Getting Insurance from Axxess
     */
    getInsurance(sessionThird) {
        if (!sessionThird) {
            return {};
        }
        const convertToArray = sessionThird.replace(/\n/g, " ");
        //Primary Insurance and Secondary Insurance
        return { insurance: convertToArray };
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from Axxess
     */
    getPrimaryPhysician(sessionSix, sessionSeven, sessionEight) {
        const primaryPhy = {
            info: {
                physician: [
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 1,
                    },
                ],
                pharmacy: [this.getPharmacy(sessionEight)],
                careGiver: [this.getCaregiver(sessionSix)],
            },
        };
        //Blank data Return
        if (!sessionSeven) {
            return primaryPhy;
        }
        //Find name
        const nameInString = sessionSeven.substr(0, sessionSeven.indexOf("NPI:"));
        //Primary Physician name
        if (nameInString) {
            const breakName = nameInString.split(",");
            primaryPhy.info.physician[0].name = `${breakName[1] ? breakName[1].trim() : ""} ${breakName[0] ? breakName[0].trim() : ""}`;
        }
        //Phone numbers string
        const numberString = sessionSeven.substring(sessionSeven.indexOf("Phone:") + 5);
        const numbers = (0, helper_1.phoneNumbers)(numberString);
        if (numbers && numbers.length) {
            const number = numbers[0] ? numbers[0].replace(/[\s-()]/g, "") : "";
            primaryPhy.info.physician[0].phoneNo = (0, helper_1.changeNumberUSFormat)(number);
        }
        //@Return
        return primaryPhy;
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        const pharmacyData = {
            name: "",
            phoneNo: "",
            countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
            sortOrder: 1,
        };
        //Blank data Return
        if (!data) {
            return pharmacyData;
        }
        data = data.trim();
        //**Find name: Before Phone:*/
        const nameInString = data.substr(0, data.indexOf("Phone:"));
        //Primary Physician name
        if (nameInString) {
            pharmacyData.name = nameInString.trim();
        }
        //**Update String for Number*/
        const numbers = (0, helper_1.phoneNumbers)(data);
        if (numbers && numbers.length) {
            const number = numbers[0].replace(/[\s-()]/g, "");
            pharmacyData.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
        }
        //@Return
        return pharmacyData;
    }
    //**Note:Caregiver details not available in Axxess software.**//
    getCaregiver(data) {
        const caregiverData = {
            name: "",
            phoneNo: "",
            countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
            sortOrder: 1,
        };
        //@Return
        return caregiverData;
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param pastedData
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(pastedData) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
            },
        };
        //**Getting patient address from between Primary Address: and Mailing Address:*/
        let addressToString = (0, helper_1.substrInBetween)(pastedData, "Primary Address:", "Mailing Address:");
        //Note: For Axxess second parser
        if (addressToString.indexOf("Phone:") != -1) {
            addressToString = addressToString.substr(0, addressToString.indexOf("Phone:"));
        }
        //Break numbers
        const numbers = (0, helper_1.phoneNumbers)(pastedData);
        //find number
        if (numbers && numbers.length) {
            const number = numbers[0] ? numbers[0].replace(/[\s-()]/g, "") : "";
            info.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
        }
        //Address
        if (addressToString) {
            //**Remove All extra Space from address */
            info.address.placeName = addressToString.trim().replace(/\s+/g, " ");
        }
        //@Return address or phoneNo
        return info;
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionParseData) {
        let sessionFirst = sessionParseData;
        const name = {
            firstName: "",
            lastName: "",
        };
        let convertToArray;
        sessionFirst = sessionFirst.replace(/Date of Referral|Referral|PATIENT PROFILE|AXXESS/gi, "$hg");
        convertToArray = sessionFirst.replace(/\n/g, "$hg").split("$hg");
        const conLen = (0, helper_1.arrayLength)(convertToArray);
        //Max check patient name 5 index
        for (let pNameIndex = conLen - 1; pNameIndex >= conLen - 5; pNameIndex--) {
            let patientName = convertToArray[pNameIndex];
            if (patientName.match(/[,)]/g)) {
                patientName = patientName.replace(/,./g, " ");
                //Replace remove all extra space from fullName
                const fullNameToArray = patientName.replace(/\s\s+/g, " ").split(" ");
                //Patient Name
                name.firstName = fullNameToArray[1]; //FirstName
                name.lastName = fullNameToArray[0]; //LastName
                break;
            }
        }
        //@Return name
        return name;
    }
}
exports.Axxess = Axxess;
